import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-clock-icon',
  template: `
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_32202_6447)">
        <path
          d="M10.1107 3C6.24512 3 3.11068 6.13444 3.11068 10H0.777344L3.8029 13.0256L3.85734 13.1344L6.99957 10H4.66623C4.66623 6.99 7.10068 4.55556 10.1107 4.55556C13.1207 4.55556 15.5551 6.99 15.5551 10C15.5551 13.01 13.1207 15.4444 10.1107 15.4444C8.60957 15.4444 7.24846 14.83 6.26846 13.8422L5.16401 14.9467C6.43179 16.2144 8.17401 17 10.1107 17C13.9762 17 17.1107 13.8656 17.1107 10C17.1107 6.13444 13.9762 3 10.1107 3ZM9.3329 6.88889V10.7778L12.6385 12.7378L13.2373 11.7422L10.4996 10.1167V6.88889H9.3329Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_32202_6447">
          <rect
            width="18.6667"
            height="18.6667"
            fill="white"
            transform="translate(0 0.666016)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClockIconComponent {}
